import React from 'react';

import { InfoCard } from '@eika/card';
import { Link, LinkType } from '@eika/link';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useConfig } from '../../../defaultConfig';
import useTranslation from '../../../hooks/useTranslation';

import './AccountNotFound.scss';

const AccountNotFound: React.FC = () => {
    const { frontPageLink } = useConfig();
    const { accountNotFound } = useTranslation();
    return (
        <InfoCard skipBackground className="account-not-found">
            <RichIcon type={RichIconTypes.PARK_M_FUGL} className="sgw-info-card__img-wrapper" />
            <InfoCard.TitleH2>{accountNotFound.noAccount}</InfoCard.TitleH2>
            {frontPageLink && (
                <Link href={frontPageLink.url} linkType={LinkType.BUTTON_SMALL_POSITIVE}>
                    {accountNotFound.toFrontPage}
                </Link>
            )}
        </InfoCard>
    );
};

export default AccountNotFound;
